<template>
<div class="container-full-width default-container p-3">
    <filtro
        :showfiltro="showfiltro"
        :params="paramsFiltro" 
        @change="filtroChange"
        @cancel="handleCloseFiltro"
    />

    <div class="row mb-3 p-3">
        <div class="col-12 lbl-deal-title mb-2">
            <span class="lbl-deal-title mb-2 w-100">CURVA ABC DE CLIENTES</span>
            <v-button label="Retornar para visões" icon="fa-bar-chart" class="float-right" @click="clickRetornar"></v-button>
        </div>
        <div class="col-md-6 col-12">
            <v-button label="Filtro" :success="true" @click="handleShowFiltro"></v-button>
        </div>
    </div>

    <div class="row" v-if="chartValues.length > 0">
        <div class="col-md-4 col-12 p-3">
            <span class="lbl-title mb-2">Resumo</span>
            <div class="p-4" style="border-top: 1px solid #dee2e6 !important; background: #fafafa">
                <!-- <span class="lbl-edit mb-5">Resumo do mês</span> -->
                <div class="resumo__performance my-5">
                    <span class="lbl-data mr-2">Valor total em pedidos</span>
                    <span class="resumo__performance__value">R$ {{ dados.total | formatValue(2) }}</span>
                </div>
                <div class="resumo__performance my-5">
                    <span class="lbl-data mr-2">Total de Clientes</span>
                    <span class="resumo__performance__value" v-if="dados.count_clientes">{{ dados.count_clientes }}</span>
                    <span v-else class="resumo__performance__value" style="">Nenhum</span>
                </div>
            </div>
        </div>
        <div class="col-md-8 col-12 p-3">
            <span class="lbl-title mb-2">Gráfico da Quantidade de Clientes</span>
            <div class="p-4" style="border-top: 1px solid #dee2e6 !important">
                <chart :params="paramsChart"></chart> 
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-12 lbl-deal-title mb-2">
            CLIENTES
            <v-button label="Excel" class="float-right" @click="loadData(true)"></v-button>
            <!-- <v-button label="Imprimr" class="float-right"></v-button> -->
        </div>
    </div>

    <div class="row mb-5">
        <div class="col-12">
            <div style="width: 100%; max-height: 100%; overflow: hidden; font-size: 12px">
                <div style="overflow: auto">

                    <table id="relatorio" class="table table-striped table-hover responsive tablesorter w-100">
                        <thead>
                            <tr style="height: 37px">
                                <th class="textual header" style="width:20%" title="">Cliente</th>
                                <th class="textual header" style="width:5%" title="">CNPJ/CPF</th>
                                <th class="textual header" style="width:10%" title="">Cidade</th>
                                <th class="textual header" style="width:2%" title="">Estado</th>
                                <th class="textual header" style="width:2%" title="">Curva</th>
                                <th class="numerico header" style="width:6%" title="">Total Vendido</th>
                                <th class="numerico header" style="width:6%" title="">% Representação</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="clientes.length == 0">
                                <td class="textual">Nenhum cliente encontrado</td>
                                <td class="textual"></td>
                                <td class="textual"></td>
                                <td class="textual"></td>
                                <td class="textual"></td>
                                <td class="numerico"></td>
                                <td class="numerico"></td>
                            </tr>
                            <tr v-else style="height: 37px" v-for="(row, index) in clientes" :key="index">
                                <td class="textual">{{ row.nome }}</td>
                                <td class="textual">{{ row.cnpjcpf | formatCNPJCPF }}</td>
                                <td class="textual">{{ row.cidade }}</td>
                                <td class="textual">{{ row.uf }}</td>
                                <td class="textual">{{ row.curva }}</td>
                                <td class="numerico">{{ row.valor | formatValue(2) }}</td>
                                <td class="numerico">{{ row.participacao_valor | formatValue(2) }}</td>
                            </tr>
                        </tbody>
                    </table>

                </div>
            </div>
        </div>
    </div>


</div>

</template>

<script>
import DashCard from '../dashboards/dash-card'
import Chart from './chart'
import Filtro from './filtro'
import { apiORDSpost } from '../shared/api-functions'
import { apiDownload2 } from '../shared/api-functions'

export default {

    components: {
        DashCard, Filtro, Chart
    },

    data () {
        return {
            showfiltro: false,

            dados: {},

            //OBJETO PARA MONTAGEM DO FILTRO DA CONSULTA
            paramsFiltro: {
                periodo: {
                    label: 'Data da venda', 
                    varios: false,
                    data_inicio: null,
                    data_termino: null,
                },

                filtros: [
                    // { nome: 'filial', label: null, url: null, varios: false, values: [] },
                    // { nome: 'segmento', label: null, url: null, varios: true, values: [] },
                    { nome: 'usuario', label: null, url: null, varios: true, values: [] },
                    { nome: 'grupocliente', label: null, url: null, varios: true, values: [] },
                ],

            },

            filtro: {
                periodos: [
                    { data_inicio: null, data_termino: null }
                ]
            },

        }
    },

    watch: {

    },

    methods: {
        handleCloseFiltro(){
            this.showfiltro = false
        },
        clickRetornar () {
            this.$router.push('/')
        },

        handleShowFiltro () {
            this.showfiltro = true
        },

        filtroChange (filtro) {

            this.showfiltro = false

            this.filtro = filtro

            this.paramsFiltro.filtros[1].values = this.filtro.grupocliente
            this.paramsFiltro.filtros[0].values = this.filtro.usuario

            this.loadData()

        },

        async loadData (excel) {
            let url = 'consulta/vendas/curvacliente'

            this.filtro.excel = excel

            if (excel)
               apiDownload2(this, url, this.filtro, 'post')
            else {
                const data = await apiORDSpost(this.$store, url, this.filtro, 'post')
                if (data) {
                    this.dados = data
                } else {
                    this.dados = {}
                }
            }
        },

    },

    computed: {
        clientes: function () {
            if (!this.dados.clientes)
                return []
            else
                return this.dados.clientes
        },

        grafico: function () {
            if (!this.dados.grafico)
                return []
            else
                return this.dados.grafico
        },

        paramsChart: function () {
            return { chart: { type: 'PieChart' }, values: this.chartValues }
            // return { chart: { type: 'AreaChart' }, values: this.chartValues }
            // return { chart: { type: 'ColumnChart' }, values: this.chartValues }
        },

        chartValues: function () {
            if (!this.clientes || this.clientes.length == 0)
              return []

            let values = [ ['', 'Quantidade de Clientes'] ]

            for (var x = 0; x < this.grafico.length; x++) {
                values.push(this.grafico[x])
            }

            return values
        },

    },

    mounted () {

    },

    created () {
        this.filtro.periodos[0].data_inicio = this.$lastDay(this.$getDate())
        this.filtro.periodos[0].data_termino = this.$firstDay(this.$getDate())

        if (this.$route.query.usuario) {
            this.filtro.usuario = [this.$route.query.usuario]
            this.paramsFiltro.filtros[0].values = [ this.filtro.usuario ]
        }

        if (this.$route.query.data_inicio) {
            this.filtro.periodos[0].data_inicio = this.$firstDay(this.$route.query.data_inicio)
            this.filtro.periodos[0].data_termino = this.$lastDay(this.$route.query.data_termino)
        }

        this.paramsFiltro.periodo.data_inicio = this.filtro.periodos[0].data_inicio
        this.paramsFiltro.periodo.data_termino = this.filtro.periodos[0].data_termino

        this.loadData()
    }

}

</script>

<style>

table .numerico {
    min-width:65px; 
    text-align: right;
}

.consulta__total {
    display: flex; 
    align-items: center; 
    justify-content: center
}

.consulta__total_valor {
    font-size: 40px; 
    display: block; 
    line-height: normal;
}

.consulta__cifrao {
    font-size: 16px; 
    display: block; 
    line-height: normal;
}


.resumo__performance {
  display: flex;
  align-items: center;
  justify-content: space-between;  
}

.resumo__performance__value {
    padding: 5px 15px;
    font-size: 18px;
    font-weight: 600;
    text-align: left;
    border-radius: 10%;
}

</style>



// WEBPACK FOOTER //
// src/consultas/consulta-curva-cliente.vue